import { trigger } from '@angular/animations';
import { LowerCasePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { maxHeightIf } from 'src/app/animations/max-height.if.animation';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { websiteHeaderStructure } from 'src/app/website-header-structure';
import { SvgComponent } from '../../components/svg/svg.component';
import { ButtonDirective } from '../../directives/button.directive';

@Component({
  selector: 'app-website-mobile-menu',
  templateUrl: './website-mobile-menu.component.html',
  styleUrls: ['./website-mobile-menu.component.scss'],
  animations: [trigger('featuresMenu', maxHeightIf(220))],
  standalone: true,
  imports: [ButtonDirective, SvgComponent, NgFor, NgIf, RouterLink, LowerCasePipe],
})
export class WebsiteMobileMenuComponent implements OnGetData {
  dialogName = 'website-mobile-menu';
  close: (...args) => void;
  featuresMenuOpen = false;
  menuStructure = websiteHeaderStructure;
  dropdownStates = {};

  dialogOptions(): DialogOptions {
    return { mobileAlignment: 'top' };
  }

  onGetData(data: unknown, close: (...args) => void) {
    this.close = close;
  }
}
